import { finalize } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { AuthService } from './auth.service';
import { LoadingBarService } from '@ngx-loading-bar/core';


@Injectable({
  providedIn: 'root'
})
export class RolesService {
  http = inject(HttpClient);
  auth = inject(AuthService)
  baseUrl = environment.baseApi
  private authLocalStorageToken = `user`;
  user = this.auth.getUser(this.authLocalStorageToken)
  loadingBar = inject(LoadingBarService)

  constructor() { }

  getRoles() {
    this.loadingBar.start()
    return this.http.get(`${this.baseUrl}/rbac/roles`)
      .pipe(finalize(() => { this.loadingBar.stop(); }))
  }
  getPermissions() {
    this.loadingBar.start()
    return this.http.get(`${this.baseUrl}/rbac/permissions`)
      .pipe(finalize(() => { this.loadingBar.stop(); }))
  }

  getSingleRole(id: any) {
    this.loadingBar.start()
    return this.http.get(`${this.baseUrl}/rbac/roles/show/${id}`)
      .pipe(finalize(() => { this.loadingBar.stop(); }))
  }
  deleteRole(id: any) {
    this.loadingBar.start()
    return this.http.delete(`${this.baseUrl}/rbac/roles/delete/${id}`)
      .pipe(finalize(() => { this.loadingBar.stop(); }))
  }
  storeRoles(data: any) {
    this.loadingBar.start()
    return this.http.post(`${this.baseUrl}/rbac/roles/store`, data)
      .pipe(finalize(() => { this.loadingBar.stop(); }))
  }
  updateRole(data: any, id: any) {
    this.loadingBar.start()
    return this.http.patch(`${this.baseUrl}/rbac/roles/update/${id}`, data)
      .pipe(finalize(() => { this.loadingBar.stop(); }))
  }
}
